import type { ErrorType } from '~/data/ErrorRecord';
import type { AddedRoboticMowerResponse } from './AddedRoboticMowerResponse';

export const defaultState: Fields = {
  isAdding: false,
  isAdded: false,
  modalIsOpen: false,
  pairingCode: '',
  machineName: '',
  addedMachine: undefined,
  error: undefined,
};

export interface Fields {
  isAdding: boolean;
  isAdded: boolean;
  modalIsOpen: boolean;
  pairingCode: string;
  machineName: string;
  addedMachine?: AddedRoboticMowerResponse;
  error?: ErrorType;
}
